import { IconName } from '@platform-frontend/ui-tools';

export type OAuthProvider = 'GITHUB' | 'FACEBOOK' | 'MICROSOFT' | 'GOOGLE' | 'LINKEDIN' | 'APPLE';

export const getOAuthProviderIcon = (provider: OAuthProvider): IconName => provider.toLowerCase() as IconName;

export const SUPPORTED_OAUTH_PROVIDERS_BY_PRIORITY: OAuthProvider[] =
  navigator.userAgent.toLowerCase().includes('iphone') ||
  navigator.userAgent.toLowerCase().includes('ipad') ||
  navigator.userAgent.toLowerCase().includes('mac')
    ? ['APPLE', 'GOOGLE', 'MICROSOFT', 'GITHUB']
    : ['GOOGLE', 'MICROSOFT', 'APPLE', 'GITHUB'];
